<template>
  <div>
    <d-row no-gutters class="page-header py-4 mb-2">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <template v-if="isInPopup">
          <h4>Lista orzeczeń</h4>
        </template>
        <template v-else>
          <h4>Lista orzeczeń pacjenta:
            <p class="mt-1 mb-0 patient-name">{{ patient.name + ' ' + patient.last_name }}</p>
          </h4>
        </template>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="success"
          @click.prevent="showAddDecisionPopup"
          :disabled="!loaded">
          <i class="material-icons">add</i>
          Dodaj orzeczenie
        </d-button>
      </d-col>
    </d-row>
    <d-card
      class="w-100"
      style="box-shadow: none;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th v-if="!filterForVisit" scope="col" class="border-0">Data wystawienia</th>
            <th scope="col" class="border-0">Orzeczenie</th>
            <th v-if="!filterForVisit" scope="col" class="border-0">Wizyta</th>
            <th scope="col" class="border-0">Specjalista</th>
            <th scope="col" class="border-0 text-center">Zarządzenia</th>
            <th scope="col" class="border-0 text-center">Plik orzeczenia</th>
            <th scope="col" class="border-0 text-center ">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(decision, decisionIndex) of decisions"
            :key="'decision-' + decisionIndex">
            <td
              v-if="!filterForVisit"
              class="align-middle">
              {{ decision.created_at.slice(0, 10) }}
            </td>

            <td class="align-middle">
              {{ decision.template_name }}
            </td>

            <td
              v-if="!filterForVisit"
              class="align-middle">
              <template v-if="decision.date_start">
                <p style="color: #17c671">{{ decision.date_start.slice(0, 11) }}</p>
                <span style="margin-top: -30px; display: block; font-size: 0.9rem; opacity: 0.6">
                  {{ decision.date_start.slice(11, 16) }} - {{ decision.date_end.slice(11, 16) }}
                </span>
              </template>
              <template v-else>
                <span style="opacity: 0.5">Brak</span>
              </template>
            </td>

            <td class="align-middle">
              {{ decision.user.name }} {{ decision.user.last_name }}
            </td>

            <td class="align-middle text-center">
              <template v-if="decision.pdf_document_ordinance_id === 0">
                <d-button
                  theme="info"
                  class="mr-2"
                  outline
                  @click.prevent="showAddOrdinancePopup(decision)"
                >
                  <i class="material-icons">add_box</i>
                  <span class="ml-2">Dodaj</span>
                </d-button>
              </template>

              <template v-else>
                <d-button
                  theme="info"
                  class="mr-2"
                  outline
                  @click.prevent="downloadOrdinance(decision.pdf_document_ordinance_id, decision.ordinance_number)"
                >
                  <i class="material-icons">download</i>
                  <span class="ml-2">Pobierz</span>
                </d-button>

                <d-button
                  theme="info"
                  class="mr-2"
                  outline
                  @click.prevent="showAddOrdinancePopup(decision)"
                >
                  <i class="material-icons">edit</i>
                  <span class="ml-2">Edytuj</span>
                </d-button>
              </template>
            </td>

            <td class="align-middle text-center">
              <d-button
                theme="info"
                class="mr-2"
                outline
                :disabled="actionInProgress !== false"
                @click.prevent="downloadDecision(decision.id)">
                <template v-if="actionInProgress !== decision.id">
                  <i class="material-icons">cloud_download</i>
                  <span v-if="!isInPopup" class="ml-2">Pobierz</span></template>
                <template v-else>
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </template>
              </d-button>
            </td>
            <td
              class="align-middle text-center"
              style="width: 130px;">
              <d-button
                theme="primary"
                @click.prevent="showEditDecisionPopup(decision)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.prevent="removeDecision(decision.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="decisions.length === 0">
            <td
              colspan="6"
              class="text-center">
              Brak orzeczeń do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <patients-form-decisions-popup
      v-if="isShowDecisionPopup"
      :all-institutions="allInstitutions"
      :on-close-popup="handleCloseDecisionPopup"
      :decision="editDecision"
      :on-submit-callback="loadItemsData"
      :patient-id="patient.id"
      :institution-id="institutionId"
      :show="true"/>

    <patients-form-ordinance-popup
      v-if="isShowOrdinancePopup"
      :decision="ordinanceDecision"
      :on-submit-callback="loadItemsData"
      :on-close-popup="handleCloseOrdinancePopup"
      :show="true"/>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import PatientsFormDecisionsPopup from '@/components/forms/patients/PatientsFormDecisionsPopup.vue';
import PatientsFormOrdinancePopup from '@/components/forms/patients/PatientsFormOrdinancePopup.vue';

export default {
  name: 'patients-form-decisions',
  props: {
    allInstitutions: {
      required: true,
      type: Array
    },
    filterForVisit: {
      default: false,
      type: Boolean
    },
    institutionId: {
      defualt: 0,
      type: Number
    },
    isInPopup: {
      default: false,
      type: Boolean
    },
    isVisible: {
      default: false,
      type: Boolean
    },
    patient: {
      required: true,
      type: Object
    },
    visitId: {
      defualt: 0,
      type: Number
    }
  },
  components: {
    'patients-form-decisions-popup': PatientsFormDecisionsPopup,
    'patients-form-ordinance-popup': PatientsFormOrdinancePopup,
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue && !this.loaded) {
        this.loadItemsData();
      }
    }
  },
  data () {
    return {
      actionInProgress: false,
      decisions: [],
      editDecision: null,
      isShowDecisionPopup: false,
      isShowOrdinancePopup: false,
      ordinanceDecision: null,
      loaded: false,
      loadError: false,
      removeInProgress: false
    }
  },
  mounted () {
    if (this.isVisible) {
      this.loadItemsData();
    }
  },
  methods: {
    loadItemsData () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);

      let where = {
        patient_id: this.patient.id
      };

      if (this.filterForVisit) {
        where.visit_id = this.visitId;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/pdf-documents/items',
        listField: 'decisions',
        pagination: false,
        params: {
          where
        }
      });
    },
    removeDecision (decisionID) {
      Vue.set(this, 'removeInProgress', true);

      ListUtils.removeItem(this, {
        endpointBase: '/pdf-documents/delete/',
        id: decisionID,
        successTitle: 'Usunięto orzeczenie',
        successText: 'Wybrane orzeczenie zostało usunięte',
        confirmTitle: 'Czy na pewno chcesz usunąć to orzeczenie?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie rzeczenia nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadItemsData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    downloadDecision (decisionID) {
      this.actionInProgress = true;

      this.$http.post('/pdf-documents/get-file/' + decisionID, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'Orzeczenie-nr-';
        link.setAttribute('download', filename + decisionID + '.pdf');
        document.body.appendChild(link);
        link.addEventListener('click', this.clickCallback, false);
        link.click();
        document.body.removeChild(link);
        this.actionInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.actionInProgress = false;
      });
    },
    downloadOrdinance (ordinanceId, ordinanceNumber) {
      this.actionInProgress = true;

      this.$http.post('/pdf-documents-ordinances/get/' + ordinanceId, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'Zarzadzenie-nr-';
        link.setAttribute('download', filename + ordinanceNumber + '.pdf');
        document.body.appendChild(link);
        link.addEventListener('click', this.clickCallback, false);
        link.click();
        document.body.removeChild(link);
        this.actionInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.actionInProgress = false;
      });
    },
    clickCallback (e) {
      e.stopPropagation();
    },
    showAddDecisionPopup () {
      Vue.set(this, 'editDecision', null);
      Vue.set(this, 'isShowDecisionPopup', true);
    },
    showEditDecisionPopup (decision) {
      Vue.set(this, 'editDecision', decision);
      Vue.set(this, 'isShowDecisionPopup', true);
    },
    handleCloseDecisionPopup () {
      Vue.set(this, 'isShowDecisionPopup', false);
      Vue.set(this, 'editDecision', null);
    },
    showAddOrdinancePopup (decision) {
      Vue.set(this, 'ordinanceDecision', decision)
      Vue.set(this, 'isShowOrdinancePopup', true);
    },
    handleCloseOrdinancePopup () {
      Vue.set(this, 'ordinanceDecision', null);
      Vue.set(this, 'isShowOrdinancePopup', false);
    }
  }
}
</script>
